<template>
  <div class="onboarding-page-wrapper">
    <div class="flex onboarding-block-wrapper">
      <img
        v-if="displayAvatar"
        class="avatar"
        src="https://logo.wondercv.com/banners/rFXnEYEDDxKYuKX.png"
        alt=""
      />
      <div class="flex flex-col">
        <div class="import-resume-container onboarding-block-container">
          <div class="import-resume-title">导入简历</div>
          <div class="import-resume-desc">上传或粘贴简历内容，系统将自动解析并导入</div>
          <div class="w-full flex items-center tab-container">
            <div
              class="tab-item"
              :class="{ active: activeTabIndex === 0 }"
              @click="clickTabItem(0)"
            >
              <span>文件上传</span>
            </div>
            <div
              class="tab-item"
              :class="{ active: activeTabIndex === 1 }"
              @click="clickTabItem(1)"
            >
              <span>文本粘贴</span>
            </div>
          </div>

          <el-upload
            v-show="activeTabIndex === 0"
            drag
            class="file-upload-wrppaer"
            accept=".doc,.docx,.pdf,.png,.jpg,.jpeg"
            :data="uploadQuery"
            :action="action"
            :show-file-list="false"
            :with-credentials="true"
            :headers="headers"
            :before-upload="beforeUpload"
            :on-success="onSuccess"
          >
            <div class="file-container flex flex-col justify-center items-center">
              <div class="text-title">拖拽简历到此区域</div>
              <div class="text-desc">支持 Word、PDF、PNG 或 JPG 等格式文件</div>
            </div>
            <OnboardingBtn text="上传简历" style="margin: 0 auto" />
          </el-upload>

          <div v-show="activeTabIndex === 1" class="resume-text-container">
            <el-input
              v-model="resumeText"
              type="textarea"
              placeholder="请将简历文本粘贴到此处，支持多种文本格式。
超级简历将自动解析并帮你生成简历"
              resize="none"
            />
          </div>
          <OnboardingBtn
            v-show="activeTabIndex === 1"
            text="开始解析"
            style="margin: 0 auto"
            :disabled="!resumeText"
            @click="textToResume"
          />
        </div>
        <div v-if="displayBackBtn" class="flex justify-end btn-container">
          <OnboardingBtn text="返回" type="plain" @clickBtn="prev" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import OnboardingBtn from './OnboardingBtn.vue';
import { getUserInfo } from '@/assets/js/util';
import { breakResumeMixin } from '../resume.mixin';
import api from '@/api/index';

export default {
  name: 'ImportResume',
  mixins: [breakResumeMixin],
  props: {
    displayAvatar: {
      type: Boolean,
      default: true,
    },
    displayBackBtn: {
      type: Boolean,
      default: true,
    }
  },
  components: {
    OnboardingBtn,
  },
  data() {
    return {
      activeTabIndex: 0,
      resumeText: '',
      action:
        (process.env.NODE_ENV == 'development' ? '/api' : process.env.API_ROOT) + '/v3/cvs/imports',
      headers: {},
      uploadQuery: {
        source: 'pc_vue',
      },
      uploading: {
        fileName: '',
        type: '', //上传文件的icon
      },
    };
  },
  methods: {
    clickTabItem(index) {
      this.activeTabIndex = index;
    },
    prev() {
      this.$emit('prevStep');
    },
    async beforeUpload(res) {
      let { name, type } = res;
      type = type.toLowerCase();
      let fileType = 'file';
      switch (true) {
        case type.includes('pdf'):
          fileType = 'pdf';
          break;
        case type.includes('word'):
          fileType = 'word';
          break;
        case type.includes('png'):
          fileType = 'png';
          break;
        case type.includes('jpg') || type.includes('jpeg'):
          fileType = 'jpg';
          break;
      }
      this.uploading.type = fileType;
      this.uploading.fileName = name;
      this.uploadQuery = { source: process.env.CLIENT, file_name: name };
      this.$emit('beforeCreateResume', {
        fileImage: `https://files.wondercv.com/resume-uploading/uploading-icon-${fileType}.png`,
        fileName: name,
        maxPercent: 95,
      });
      this.$emit('nextStep');
    },
    onSuccess(res) {
      if (res?.code === 1000) {
        this.$emit('resumeChange', res.data.cv_token);
      } else if (res?.code === 3001) {
        this.$message.error(res?.message);
        this.$store.dispatch('app/setAlertData', {
          show: true,
          type: 'upVip',
          browseType: 'cvImport',
        });
        this.$emit('prevStep');
      } else if (res?.code === 3000) {
        this.memberResumeLimit(res);
        this.$emit('prevStep');
      } else {
        this.$message.error(res?.message);
        this.$emit('prevStep');
      }
      
    },
    async textToResume() {
      try {
        this.$emit('nextStep');
        this.$emit('beforeCreateResume', {
          fileImage: `iconfont iconai-resume`,
          fileName: '正在解析文本',
          maxPercent: 95,
        });
        const res = await api.AI.getTextToResumeResult({
          cv_data: this.resumeText,
        });
        if (res.code === 1000) {
          this.$emit('resumeChange', res.data.cv_token);
        } else if (res?.code === 3001) {
          this.$message.error(res?.message);
          this.$store.dispatch('app/setAlertData', {
            show: true,
            type: 'upVip',
            browseType: 'cvImport',
          });
          this.$emit('prevStep');
        } else if (res.code === 3000) {
          this.memberResumeLimit(res);
          const timer = setTimeout(() => {
            this.$emit('prevStep');
            clearTimeout(timer);
          }, 500);
        } else {
          this.$message.error(res?.message);
          this.$emit('prevStep');
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  async mounted() {
    const userInfo = await getUserInfo();
    this.headers = {
      'Access-Control-Allow-Origin': '*',
      authorization: userInfo.Authorization,
    };
  },
};
</script>
<style lang="scss" scoped>
@import '../styles/index.scss';
.import-resume-container {
  width: 580px;
  .import-resume-title {
    font-size: 16px;
    color: #fff;
    margin-bottom: 8px;
  }
  .import-resume-desc {
    color: #9a9ca2;
    font-size: 12px;
  }
  .tab-container {
    padding: 4px;
    border-radius: 8px;
    background-color: #3e4148;
    margin-top: 20px;
    .tab-item {
      flex: 1;
      height: 36px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      border-radius: 4px;
      cursor: pointer;
      &.active {
        background-color: #272b33;
        span {
          background: linear-gradient(90deg, #ffbc52 0%, #f5523b 100%);
          background-clip: text;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          font-weight: 500;
        }
      }
    }
  }
  .file-upload-wrppaer {
    margin-top: 20px;
    width: 100%;
    :deep(.el-upload) {
      width: 100%;
      .el-upload-dragger {
        width: 100%;
        height: auto;
        background-color: transparent;
        border: none;
        .file-container {
          width: 100%;
          height: 200px;
          border-radius: 8px;
          border: 1px dashed #737b8c;
          background-color: #2e3138;
          margin-bottom: 20px;

          .text-title {
            font-size: 16px;
            color: #fff;
            font-weight: 500;
            margin-bottom: 12px;
          }
          .text-desc {
            font-size: 12px;
            color: rgba($color: #fff, $alpha: 0.8);
          }
        }
      }
    }
  }
  .resume-text-container {
    margin: 20px 0;
    .el-textarea {
      :deep(.el-textarea__inner) {
        border-radius: 8px;
        background: rgba(255, 255, 255, 0.1);
        border: none;
        padding: 14px 16px;
        height: 200px;
        color: #fff;
        &::placeholder {
          color: #9a9ca2;
        }
      }
    }
  }
}
.btn-container {
  margin-top: 32px;
  .onboarding-btn-container {
    width: 92px;
  }
}
</style>
